module.exports = __webpack_public_path__ + "static/media/3.4ab624ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/buy/3.png
// module id = 1092
// module chunks = 0